import axios from 'axios'
import store from '../store/store'
import CONFIG from '../config/config'

var makeCall = (reqObj) => {
    // These are the store variables to reset the session timeOut timer.
    store.state.appStore.sessionManagement.resetSession = false
    store.state.appStore.sessionManagement.resetSession = true

    var rTrackID = Math.random()
        .toString(36)
        .slice(2)

    reqObj.headers = reqObj.headers || {};

    if (CONFIG.developmentMode === true && sessionStorage.getItem('token')) {
        var authHeaders = [];
        authHeaders.push('rsession=' + sessionStorage.getItem('usersession'));
        authHeaders.push('token=' + sessionStorage.getItem('token'));
        reqObj.headers.Authorization = authHeaders.join(';');
    }

    if (!store.state.appStore.utid) {
        store.state.appStore.utid = Math.random()
            .toString(36)
            .slice(2)
    }
    reqObj.headers.utid = store.state.appStore.utid
    reqObj.headers.rtid = rTrackID

    return new Promise(function (resolve, reject) {
        axios(reqObj).then(response => {
            if (CONFIG.developmentMode === true && response.data.token) {
                sessionStorage.setItem('token', response.data.token);
                sessionStorage.setItem('usersession', response.data.userSession);
            }
            resolve(response);
        }).catch(error => {
            if (CONFIG.developmentMode === true) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('usersession');
            }
            if (error && error.response && error.response.data && error.response.data.invalideSession) {
                var appUrl = location.protocol + '//' + location.host + '/';
                window.location.href = appUrl;
            } else {
                reject(error);
            }
        })
    })
};

export default {
    makeCall
}



